module.exports = __webpack_public_path__ + "img/img_skin_4.c6a51180.png";